<p-dialog
  [header]="title"
  [(visible)]="show"
  [modal]="true"
  [style]="{ width: '330px', margin: '1rem' }"
  [closable]="closeable"
  [baseZIndex]="10000"
  (onHide)="onCancel()">
  <div class="space-y-5">
    <div class="flex justify-center" *ngIf="loading">
      <ng-lottie class="w-[150px]" [options]="options"></ng-lottie>
    </div>
    <p class="text-P whitespace-pre-line center" [ngClass]="{ 'font-bold': loading }">
      {{ text }}
    </p>
  </div>
</p-dialog>
